module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-scripts/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = 4
// module chunks = 0